<template>
    <div>
        <vue-spinner v-if="loading"></vue-spinner>
        <template v-else>

            <div v-if="referral.status === 'not_enrolled'" id="accordion1" class="panel-group accordion">
                <div class="panel panel-default">
                    <div class="panel-heading"><h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion1" href="#collapse_1"
                           class="accordion-toggle collapsed" aria-expanded="true">Not Enrolled Reason <i
                                class="pull-right fa"></i></a></h4>
                    </div>
                    <div id="collapse_1" class="panel-collapse collapse in" aria-expanded="true">
                        <div class="panel-body">
                            <div class="form-group">
                                <div class="form-group">
                                    <label class="control-label">* Not Enrolled Reason</label>
                                    <textarea class="form-control"
                                              rows="6"
                                              disabled="disabled"
                                    >{{referral.comment}}</textarea>
                                </div>
                            </div>
                            <h4>Activity Logging</h4>
                            <span>Not Enrolled By: <strong>{{referral.last_action_user_name}}</strong> at {{referral.last_action_at.date | formatDateModal}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <vue-form-render
                    :schema="currentForm.schema"
                    :conditions="currentForm.conditions"
                    :hideValues="currentForm.hideValues"
                    :calculations="currentForm.calculations"
                    :validation-conditions="currentForm.extra_validation_rules"
                    :values="currentForm.values"
                    :date-format="user.date_format"
                    :user-access-level="1"
                    :name="'referral-form'"
                    :lockform="true"
                    :referral-destination-accounts="referralDestinationAccounts">
            </vue-form-render>

            <template v-if="referral.status === 'pending' && user.access >= 4">
                <hr>
                <router-link :to="{name: 'Add Participant from Referral', params: {referralId: id}}" class="btn green">
                    <i class="fa fa-plus"></i> Add {{ participantSingularName }}
                </router-link>
                <button @click="notEnrolled" class="btn default">
                    Not Enrolled
                </button>
            </template>

            <template v-if="referral.status === 'not_enrolled'  && user.access >= 4">
                <hr>
                <router-link :to="{name: 'Add Participant from Referral', params: {referralId: id}}" class="btn green">
                    <i class="fa fa-plus"></i> Add {{ participantSingularName }}
                </router-link>
            </template>

            <a @click="printPage('/print/form/'+referral.data_id)" class="btn default" :class="{'pull-right' : user.access >= 4}">Print</a>
        </template>

        <div class="modal" id="not-enrolled-reason-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title uppercase">Referral - Not enrolled</h4></div>

                    <div v-if="referralUpdating" class="margin-bottom-20 margin-top-20">
                        <vue-spinner></vue-spinner>
                    </div>

                    <template v-else>
                        <div class="modal-body">
                            <div class="form-group">
                                <label class="control-label">{{ participantSingularName }} Name</label>
                                <input type="text" class="form-control" :value="referral.participant_name"
                                       disabled="disabled">
                            </div>
                            <div class="form-group">
                                <label class="control-label">* Not Enrolled Reason</label>
                                <textarea class="form-control"
                                          v-model="notEnrolledComment"
                                          rows="6"
                                          @input="onNotEnrolledCommentInput"></textarea>
                                <span class="pull-right">{{1000 - notEnrolledComment.length }} Characters Remaining </span>
                                <span v-show="notEnrolledError" class="error-msg help-block" style="color: #f00">This fields is required</span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button id="session-timeout-dialog-keepalive" type="button" class="btn green pull-right"
                                    @click="notEnrolledConfirm">
                                Not Enrolled
                            </button>
                        </div>


                    </template>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {ERROR, HTTP} from '@/http-common';
    import {mapActions, mapGetters} from 'vuex';
    import VueFormRender from "../../components/formbuilder/VueFormRender";
    import Spinner from "../../components/Spinner";
    import participantDisplayName from '@/mixins/participantDisplayName';

    export default {
        mixins: [
          participantDisplayName
        ],
        name: 'ReferralSubmission',
        components: {
            VueFormRender,
            'vue-spinner': Spinner
        },
        props: ['id'],
        data() {
            return {
                currentForm: {
                    name: '',
                    schema: [],
                    conditions: [],
                    calculations: [],
                    values: [],
                    hideValues: [],
                    info: []
                },
                referral: {},
                loading: false,
                referralUpdating: false,
                notEnrolledComment: '',
                notEnrolledError: false,
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                organization: 'getOrganization'
            }),
            referralDestinationAccounts() {
                let destinationAccountValue = Object.keys(this.currentForm.values).find(item => {
                   if(item.startsWith('destination-account')) {
                       return this.currentForm.values[item];
                   }
                });

                if (destinationAccountValue && this.currentForm.values.hasOwnProperty(destinationAccountValue)) {
                    return [this.organization.name, this.currentForm.values[destinationAccountValue]]
                }

                return [this.organization.name]
            }
        },
        mounted() {
            if (this.id) {
                this.fetchForm()
            }
        },
        methods: {
            ...mapActions({
                fetchReferrals: 'referrals/fetchIndexGrouped'
            }),
            fetchForm() {
                this.loading = true;
                HTTP.get('/referrals/get/' + this.id).then(response => {
                    if (response.data.status === 'success') {
                        this.referral = response.data.data.referral;
                        HTTP.post(`/form/data`, {data_id: response.data.data.referral.data_id})
                            .then(response => {
                                ERROR(response);
                                if (response.data.status === 'success') {
                                    this.currentForm.name = response.data.data.form.name;
                                    this.currentForm.schema = JSON.parse(response.data.data.form.data);
                                    this.currentForm.conditions = JSON.parse(response.data.data.form.conditionals);
                                    this.currentForm.calculations = JSON.parse(response.data.data.form.calculations);
                                    this.currentForm.extra_validation_rules = JSON.parse(response.data.data.form.extra_validation_rules);
                                    this.currentForm.hide_values = JSON.parse(response.data.data.form.hide_values);
                                    this.currentForm.values = response.data.data.values;
                                    this.currentForm.info = response.data.data.form_data;
                                    this.loading = false;
                                }
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    }

                }).catch(err => {
                    console.log(err);
                });
            },

            notEnrolled() {
                this.notEnrolledComment = '';
                this.notEnrolledError = false;
                $('#not-enrolled-reason-modal').modal('show');
            },

            notEnrolledConfirm() {
                if (!this.notEnrolledComment.length) {
                    this.notEnrolledError = true;
                    return;
                }

                this.referralUpdating = true;

                HTTP.post('/referrals/set-not-enrolled', {
                    referral_id: this.id,
                    comment: this.notEnrolledComment,
                    status: 'not_enrolled'
                }).then(response => {
                    if(response.data.status === 'success') {
                        this.referral = response.data.data.referral;
                    }
                }).catch(error => {
                    console.log(error);
                }).then(() => {
                    this.fetchReferrals();
                    this.referralUpdating = false;
                    $('#not-enrolled-reason-modal').modal('hide');
                });
            },

            onNotEnrolledCommentInput() {
                if (this.notEnrolledComment.length > 1000) {
                    this.notEnrolledComment = this.notEnrolledComment.slice(0, 1000);
                }
            },

            printPage(url) {
                window.open(url, 'Print', 'left=0, top=0, width=1200, height=500, toolbar=0, resizable=0');
            },
        },
        watch: {
            'id': function () {
                this.fetchForm();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ReferralSubmission.vue?dbbcedca